/** /user/queryAllUser：兼容 data 为数组、{ result: [] } 或单条用户对象。 */
export function parseUserPickerList(res) {
  const d = res && res.data;
  if (!d) return [];
  if (Array.isArray(d)) return d;
  const r = d.result;
  if (Array.isArray(r)) return r;
  if (r && typeof r === "object" && r.id) return [r];
  if (d.id) return [d];
  return [];
}

export function loginUserId(info) {
  if (!info) return "";
  return info.user_id || info.userId || "";
}

export function isNeedChangePassword(info) {
  if (!info || info.is_manage) {
    return false;
  }
  return info.pwd_changed === 0 || info.pwd_changed === "0";
}

export function isSuperAdmin(info) {
  return !!(info && (info.user_id === "100000" || info.is_super_admin));
}

export function applyAccountQuotaToLogin(store, setCookie, profile) {
  if (!store || !profile) {
    return;
  }
  const cur = (store.state && store.state.loginAccountInfo) || {};
  const cap =
    profile.free_capacity != null
      ? profile.free_capacity
      : profile.freeCapacity != null
      ? profile.freeCapacity
      : cur.free_capacity;
  const next = {
    ...cur,
    projects: profile.projects != null ? profile.projects : cur.projects,
    pages: profile.pages != null ? profile.pages : cur.pages,
    free_capacity: cap,
    freeCapacity: cap,
  };
  store.commit("setLoginAccountInfo", next);
  if (typeof setCookie === "function") {
    setCookie("loginAccountInfo", JSON.stringify(next), 7 * 24 * 60 * 60 * 1000);
  }
}

export function compressAvatar(file, maxSize = 200) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = maxSize;
        canvas.height = maxSize;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, maxSize, maxSize);
        const scale = Math.max(maxSize / img.width, maxSize / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        ctx.drawImage(img, (maxSize - w) / 2, (maxSize - h) / 2, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
